import React, { useContext, useEffect, useRef, useState } from "react";
import "./admintable.css";
import Topbar from "../Global/topbar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import TableBody2 from "../Table container/tablebody";
import CachedIcon from "@mui/icons-material/Cached";
import { deleteAdmin, getAdmin } from "../../services/api/admin";
import { handleToast } from "../../utils";
import { toast } from "react-toastify";
import { Context } from "../../context/contextapi";

export default function AdminTable() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [loader, setLoder] = useState(true);
  const [data, setData] = useState(false);
  const [notfound, setNotFound] = useState(false);
  const [APIdata, setAPIdata] = useState([]);
  const menu = true;
  const [limit, setLimit] = useState(5);
  const [total, setTotal] = useState(0);
  const [skip, setSkip] = useState("");
  const [reload, setReload] = useState();
  const [pages, setPages] = useState("");
  const deleted = false;
  const start_key = useRef({ 1: null });
  const page = useRef(1);
  const activete_data = "true";
  const reset = true;
  const location = useLocation();
  const isMobile = window.innerWidth <= 600;
  const { setHasmore} = useContext(Context);

  useEffect(() => {
    setPages((prev) => !prev);
  }, [search]);
  useEffect(() => {
    const start = JSON.parse(sessionStorage.getItem("start_key"));
    const URI = JSON.parse(sessionStorage.getItem("path"));
    if (start && location.pathname === URI) {
      start_key.current = start;
    } else {
      start_key.current = { 1: null };
    }
  }, [location]);

  const handleclick = () => {
    navigate("/admin/super_admin/create_super_admin");
  };
  const headers = [
    { topic: "#" },
    { topic: "Name" },
    { topic: "Id" },
    { topic: "Role" },
    { topic: "Email" },
    // {topic : 'Phone Number'},
    { topic: "Active" },
    // {topic : 'Photo'},
    { topic: "Action" },
  ];

  const fetchAdmin = async () => {
    const paginationKey = start_key.current[page.current];
    getAdmin(search, limit, paginationKey)
      .then((response) => {
        if (response.data.status) {
          if (response?.data?.data?.data.length === 0) {
            setLoder(false);
            setNotFound(true);
            setData(true);
            setTotal(response?.data?.data?.total);
            setHasmore(false)
          } else {
            setLoder(false);
            setNotFound(false);
            setData(true);
            setTotal(response?.data?.data?.total);
            setAPIdata(response?.data?.data?.data || []);
            start_key.current[page.current + 1] =
              response?.data?.data?.last_key || null;
            if (response?.data?.data?.last_key) {
              setHasmore(true)
            } else {
              setHasmore(false)
            }
            sessionStorage.setItem(
              "start_key",
              JSON.stringify(start_key.current),
            );
          }
        } else {
          setLoder(false);
          setHasmore(false);
          setNotFound(true);
        }
      })
      .catch((error) => {
        setLoder(false);
        setNotFound(true);
        setHasmore(false);
        console.log(error.message);
      });
  };

  useEffect(() => {
    setAPIdata([]);
    setLoder(true);
    setNotFound(false);
    const delayDebounceFn = setTimeout(() => {
      fetchAdmin();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [search, skip, limit, reload]);

  const handleReload = () => {
    setReload((prev) => !prev);
  };

  const cell = [
    { topic: "name" },
    { topic: "id" },
    { topic: "entity" },
    { topic: "email" },
    // {topic : 'number'},
    { topic: "active" },
    // {topic : 'photo'}
  ];

  const path = "/admin/super_admin/admin_details";

  const handleDeleted = async (id) => {
    setReload((prev) => !prev);
    try {
      deleteAdmin(id)
        .then(() => {
          toast.success("Success! Admin deleted", {
            position: isMobile ? "top-left" : "top-center",
            style: {
              width: isMobile ? "300px" : "400px",
              textWrap: isMobile && "wrap",
            },
          });
        })
        .catch((error) => {
          handleToast(error);
        });
    } catch (error) {
      handleToast(error);
      console.log(error.message);
    }
  };

  return (
    <div className="AdminTable-main">
      <div className="AdminTable-user">
        <Topbar />
        <div className="top-mid-Admin">
          <h1>Admin List</h1>
          <Link to="" style={{ display: "none" }}>
            Dashboard
          </Link>{" "}
          <Link to="/admin/super_admin">Admin List</Link> &#62;
        </div>
        <div className="tob-bottom-Admin">
          <div className="button-box-user">
            <button onClick={handleclick}> + Create Admin</button>
          </div>
          <div>
            <input
              type="text"
              className="input-Admin"
              placeholder="&#61442; Search"
              onChange={(e) => {
                setSearch(e.target.value);
                setSkip(0);
                start_key.current[1] = undefined;
                page.current = 1;
                sessionStorage.setItem("newPage", 1);
              }}
              style={{
                fontfamily: "Arial, FontAwesome",
                marginRight: "4px",
              }}
            />
            <button onClick={handleReload}>
              <CachedIcon />
            </button>
          </div>
        </div>
        <div className="table1">
          <TableBody2
            headers={headers}
            APIdata={APIdata}
            cell={cell}
            path={path}
            loader={loader}
            notfound={notfound}
            data={data}
            menu={menu}
            setSkip={setSkip}
            total={total}
            setLimit={setLimit}
            pages={pages}
            deleted={deleted}
            newPage={page}
            setReload={setReload}
            activete_data={activete_data}
            reset={reset}
            search={search}
            handleDeleted={handleDeleted}
          />
        </div>
      </div>
    </div>
  );
}
